import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@one-thd/sui-atomic-components';

/**
 * LeftNavSection Component
 *
 * @param {Object} opts - Navigation options object
 * @param {string} opts.id - Unique identifier for the nav section
 * @param {string} opts.heading - Section heading
 * @param {Array} opts.links - Array of link objects
 * @param {number} opts.links[].id - Link ID
 * @param {string} opts.links[].linkText - Display text for the link
 * @param {string} opts.links[].link - URL for the link
 */
export const LeftNavSection = ({ opts }) => {
  if (!opts || !opts.links || opts.links.length === 0) {
    return null;
  }

  return (
    <div className="sui-pb-5" data-testid={`left-nav-${opts.id}`}>
      {opts.heading && (
        <div className="sui-pb-2">
          <Typography variant="body-sm" weight="bold">
            {opts.heading}
          </Typography>
        </div>
      )}
      <nav>
        <ul>
          {opts.links.map((link) => (
            <li key={link.id} className="sui-pb-2">
              <Link
                href={link.link}
                variant="body-sm"
                underline="hover"
              >
                {link.linkText}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

LeftNavSection.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    heading: PropTypes.string,
    links: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        linkText: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired
      })
    ).isRequired
  }).isRequired
};

export default LeftNavSection;
